import React, { useEffect } from 'react';
import NoteList from './NoteList';
import NoteEditor from './NoteEditor';
import uuid from 'react-uuid';

const Main = ({ cat_filters, activeCatFilter, activeFilter, notes, setNotes, activeNote, setActiveNote, filteredNotes, setFilteredNotes, searchNote, setActiveCatFilter, setActiveFilter, original_cat_filters, filters }) => {

    const addNewNote = () => {
        const newNote = {
            id: uuid(),
            title: '',
            content: '',
            categories: [1],
            favorite: false,
            completed: false
        }

        setActiveNote(newNote);
        setActiveCatFilter( original_cat_filters[0] );
        setActiveFilter( filters[0] );
        setNotes([newNote, ...notes]);

    }

    const onDeleteNote = (idToDelete) => {
        setNotes(notes.filter((note) => note.id !== idToDelete));
    }

    const getActiveNote = () => {
        return notes.find((note) => note.id === activeNote.id);
    }

    const onUpdateNote = (updatedNote) => {
        const updatedNotesArray = notes.map((note) => {

            if (note.id === activeNote.id) {
                return updatedNote;
            }

            return note;
        });
        setNotes(updatedNotesArray);
    };

    const setFavoriteNote = (idToFav) => {
        const newNotes = [...notes];
        const note = newNotes.find((note) => note.id === idToFav);
        note.favorite = !note.favorite;

        setNotes(newNotes);
    };
    const setCompleteNote = (idToComplete) => {
        const newNotes = [...notes];
        const note = newNotes.find((note) => note.id === idToComplete);
        note.completed = !note.completed;

        setNotes(newNotes);
    };

    const updateNoteCategories = (noteId, categoryId) => {
        const newNotes = [...notes];
        const note = newNotes.find((note) => note.id === noteId);

        let categories = note.categories;

        let index = categories.indexOf(categoryId);
        if (index !== -1) {
            categories.splice(index, 1);
        } else {
            categories.push(categoryId)
        }

        note.categories = categories;

        setNotes(newNotes);
    }

    const filterHandler = () => {
        switch (activeFilter.id) {
            case 1:
                setFilteredNotes(notes.filter((note) => !note.completed && (note.categories.includes(activeCatFilter.id))
                    && note.title.toLowerCase().includes(searchNote.toLowerCase())))
                break;
            case 2:
                setFilteredNotes(notes.filter((note) => note.completed && (note.categories.includes(activeCatFilter.id))
                    && note.title.toLowerCase().includes(searchNote.toLowerCase())))
                break;
            default:
                setFilteredNotes(notes.filter((note) => note.categories.includes(activeCatFilter.id) && note.title.toLowerCase().includes(searchNote.toLowerCase())));
                break;
        }
    }

    useEffect(() => {
        filterHandler();
    }, [notes, activeFilter, activeCatFilter, searchNote])


    return (<div className="app-main">
        <NoteList
            notes={notes}
            onDeleteNote={onDeleteNote}
            activeNote={activeNote}
            setActiveNote={setActiveNote}
            setFavoriteNote={setFavoriteNote}
            setCompleteNote={setCompleteNote}
            filteredNotes={filteredNotes}
        />
        <NoteEditor
            addNewNote={addNewNote}
            activeNote={getActiveNote()}
            onUpdateNote={onUpdateNote}
            onDeleteNote={onDeleteNote}
            setFavoriteNote={setFavoriteNote}
            setCompleteNote={setCompleteNote}
            cat_filters={cat_filters}
            updateNoteCategories={updateNoteCategories}
        />
    </div>)
}

export default Main;